import { httpClientCDN } from 'Api/microservice-http-clients';
import CONFIG from './config';

const fallbackPath = '/explore';

try {
  const jsVersion = window.__jsVersion || __jsVersion__;
  if (jsVersion) {
    const randomString = Math.random().toString(36).slice(2);
    httpClientCDN.get(`/current-version.json?ver=${randomString}`)
      .then(({ data: fileVersion }) => {
        // If there is no one of hash or they are the same, do noting
        if (!fileVersion || String(fileVersion) === String(jsVersion)) return;
        // If it is fallback page
        if (window.location.pathname === fallbackPath) {
          // try to get reloaded hash before
          const reloadedForVersion = localStorage.getItem('reloadedForVersion');
          // If it exist and was reload before, do nothing
          if (reloadedForVersion && reloadedForVersion === fileVersion) return;
          // Otherwise save file hash to store
          localStorage.setItem('reloadedForVersion', fileVersion);
          // eslint-disable-next-line no-console
          console.warning('Wrong JS bundle version detected. Run force reload page');
          if (CONFIG.isEnvDev || CONFIG.isEnvStag) {
            // eslint-disable-next-line no-alert
            alert(`
              Page will be reload!
              --------------------------------------
              Reason: js files are outdated
              --------------------------------------
              note: this message showing only on dev and staging
            `);
          }
          window.$__forceReload = true; // to do not confirm by user to reload page
          // End reload page with reload
          window.location.reload(true);
        } else {
          // eslint-disable-next-line no-console
          console.warn(`Wrong JS bundle version detected. Redirect to ${fallbackPath}`);
          window.$__forceReload = true; // to do not confirm by user to reload page
          // Redirect to fallback page
          document.location.href = fallbackPath;
        }
      })
      .catch(() => {
        // ignore any errors;
      });
  }
} catch (e) {
  // ignore any errors
}
